import * as HomeStore from './store'

export function homeModule({ store }) {
  store.registerModule('home', { ...HomeStore, namespaced: true })
}
